import Vue from 'vue'

import './styles/quasar.styl'
import 'quasar/dist/quasar.ie.polyfills'
import lang from 'quasar/lang/fr.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'

import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QChip,
	QAvatar,
	QInput,
	QSelect,
	QCard,
	QCardSection,
  QCardActions,
  QTabs,
  QTab,
  QTabPanels,
  QTabPanel,
  QFooter,
  QDialog,
  QSpace,
  ClosePopup,
  QVideo,
  QCarousel,
  QCarouselControl,
  QCarouselSlide,
  QImg,
} from 'quasar'

Vue.use(Quasar, {
  config: {
  },
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QChip,
    QAvatar,
    QInput,
    QSelect,
    QCard,
    QCardSection,
    QCardActions,
    QTabs,
    QTab,
    QTabPanels,
    QTabPanel,
    QFooter,
    QDialog,
    QSpace,
    QVideo,
    QCarousel,
    QCarouselControl,
    QCarouselSlide,
    QImg,
  },
  directives: {
    ClosePopup
  },
  plugins: {

  },
  lang: lang
 })